import React, {Fragment, useContext} from "react";
import {Button, Box} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import UserContext from "../../contexts/UserContext";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import NotificationButton from "../notifications/NotificationButton";
import {getCurrentUserRole} from "../../api/usersApi";
import {Role} from "myfitworld-model";
import MessageButton from "../chat/MessageButton";
import organizationsMessages from "./messages";
import { useIntl } from "react-intl";
import HelpSection from "../notifications/HelpSection";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notification:{
      marginTop:"0px",
      height:"100%",
      display:"flex",
      alignItems:"center",
      justifyContent:"flex-end",
    },
    [theme.breakpoints.down("sm")]: {
      wrapper: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),

        "& div": {
          width: "100%",
        },
      },
    },
  })
);

export default () => {
  const {formatMessage} = useIntl();
  const userContext = useContext(UserContext);
  const classes = useStyles();

  return (
    <Fragment>
      {userContext.organizationOverride && (
        <div className={classes.wrapper}>
          <Button
            variant="text"
            color="secondary"
            startIcon={<ArrowBackIosIcon/>}
            onClick={() => {
              userContext.setOrganizationOverride(undefined);
            }}
          >
            {formatMessage(organizationsMessages.go_back_to_super_admin_dashboard)}
          </Button>
        </div>
      )}

      {
        ((userContext.user && getCurrentUserRole(userContext.user) !== Role.SuperAdmin) ||
          (userContext.user && getCurrentUserRole(userContext.user) === Role.SuperAdmin && !!userContext.organizationOverride)
        )
        &&
          <Box className={classes.notification} px={2} mt={2}>
            <HelpSection/>
            <MessageButton/>
            <NotificationButton/>
          </Box>
      }
    </Fragment>
  );
};
